import thunkMiddleware from "redux-thunk";
import { persistStore, persistReducer } from "redux-persist";
import { createStore, compose, applyMiddleware } from "redux";
import storageSession from "redux-persist/lib/storage/session";
// import { composeWithDevTools } from 'redux-devtools-extension';

import Reducer from "../reducer/reducer";
import sessionService from "../services/sessionService";

const configStore = ({ initialState }) => {
  const persistConfig = {
    key: "root",
    storage: storageSession,
    whitelist: ["sessionInfoReducer", "countriesReducer", "creditLineReducer"],
  };

  const persistedReducer = persistReducer(persistConfig, Reducer);

  const saveAuthToken = () => next => action => {
    switch (action.type) {
      case 'SAVE_SESSION':
        sessionService.setToken(action.payload.session.opaque);
        sessionService.setUser(action.payload);
        break;
      case 'SAVE_SESSION_REGISTER': sessionService.setToken(action.payload.register.jwt); break;
      case 'SAVE_SESSION_DUMMY': sessionService.setToken(action.payload.validateUser.jwt); break;
      case 'RENEW_SESSION': sessionService.setToken(action.payload.opaque); break;
      case 'DELETE_SESSION':
        sessionService.setToken(false);
        sessionService.setUserType(sessionService.getUser().userType);
        sessionService.setUser({});
        break;
      case 'persist/REHYDRATE':
        if (action.payload !== undefined) {
          sessionService.setToken(action.payload.sessionInfoReducer.sessionInfo.session);
          sessionService.setUser(action.payload.sessionInfoReducer.sessionInfo);
        }
        break;
    }
    // continue processing this action
    return next(action);
  };

  const composeEnhancers = typeof window === 'object' &&
  window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ?
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
      // Specify extension�s options like name, actionsBlacklist, actionsCreators, serialize...
    }) : compose;

  const store = createStore(
    persistedReducer,
    initialState,
    composeEnhancers(applyMiddleware(thunkMiddleware, saveAuthToken))
  );

  // compose(composeWithDevTools(applyMiddleware(thunkMiddleware, saveAuthToken)))
  // compose(applyMiddleware(thunkMiddleware, saveAuthToken))

  const persistor = persistStore(store);
  return { store, persistor };
};
// Init the session service

export default configStore;
